<template>
  <div>
    <el-page-header @back="goBack" content="统计报表"> </el-page-header>
    <div id="myChart" :style="{ width: '400px', height: '400px' }"></div>
  </div>
</template>
<script>
import Api from '../apis/playerchart'
export default {
  data () {
    return {
    }
  },
  mounted () {
    Api.getChart({ matchId: this.$route.query.matchId, }).then(res => {
      var echarts = require('echarts');
      let myChart = echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        title: { text: '年龄分组' },
        series: [{
          name: '人数',
          type: 'pie',
          radius: '55%',
          data: res.result
        }]
      });
    })
  },
  methods: {
    goBack () {
      this.$router.push({ path: '/matches' })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/PlayerChart.vue